export default {
    SET_CATEGORIES(state,categories){  state.Categories = categories; },
    SET_PRODUCT_DATA(state,product){  state.product = product}
}